import './dev/quiet-wds-logs';
import './global.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from './components/common/ScrollToTop'; // <-- path

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollToTop />   {/* ensures top-of-page on every route change */}
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

